import { ArrowRight, Envelope, ExclamationCircle, Lightbulb, Receipt } from 'react-bootstrap-icons';

const CONTACT_EMAIL = 'budgetvenlig@gmail.com';

function Contact() {
  return (
    <main className="contact-page" aria-labelledby="contact-title">
      <header className="contact-hero">
        <div>
          <span className="contact-kicker">Kontakt Budgetvenlig</span>
          <h1 id="contact-title">Vi vil gerne høre fra dig</h1>
          <p>
            Har du fundet en forkert pris, en opskrift der driller, eller har du en idé til siden?
            Skriv direkte til os, så tager vi et kig på det.
          </p>
        </div>
        <a
          href={`mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent('Henvendelse til Budgetvenlig')}`}
          className="contact-email-card"
        >
          <span className="contact-email-icon" aria-hidden="true"><Envelope /></span>
          <span>
            <small>Send en e-mail</small>
            <strong>{CONTACT_EMAIL}</strong>
          </span>
          <ArrowRight aria-hidden="true" />
        </a>
      </header>

      <section className="contact-panel" aria-labelledby="contact-help-title">
        <div className="contact-panel-heading">
          <span>Det hjælper os, hvis du skriver</span>
          <h2 id="contact-help-title">Hvad din henvendelse drejer sig om</h2>
        </div>
        <div className="contact-topic-grid">
          <article>
            <span aria-hidden="true"><Receipt /></span>
            <h3>Priser og tilbud</h3>
            <p>Fortæl hvilken vare, butik eller madplan det gælder, og gerne hvilken pris du så.</p>
          </article>
          <article>
            <span aria-hidden="true"><ExclamationCircle /></span>
            <h3>Fejl på siden</h3>
            <p>Beskriv hvad du gjorde, og hvad der skete. Et skærmbillede er meget velkomment.</p>
          </article>
          <article>
            <span aria-hidden="true"><Lightbulb /></span>
            <h3>Idéer og feedback</h3>
            <p>Fortæl hvad der ville gøre Budgetvenlig mere nyttig i din hverdag.</p>
          </article>
        </div>
      </section>

      <aside className="contact-beta-note">
        <strong>Én tydelig kontaktkanal mens vi er i beta</strong>
        <p>
          E-mail er vores primære kontaktform lige nu. Der er endnu ikke telefon- eller livechat-support,
          men alle henvendelser lander samme sted og hjælper os med at forbedre Budgetvenlig.
        </p>
      </aside>
    </main>
  );
}

export default Contact;
